import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import * as St from './index.styled';

export function WegetTabs({
    currentTab,
    onSetTab
}) {
    return (
        <>
            <St.Tabs.Container>
                <St.Tabs.Wrapper>
                    {TAB_LIST?.map(tab => {
                        return (
                            <CustomBlockButton
                                key={tab?.value}
                                type='button'
                                onClick={() => onSetTab(tab?.value)}
                                className={`${currentTab === tab?.value ? 'active' : ''}`}
                            >{tab?.name}</CustomBlockButton>
                        );
                    })}
                </St.Tabs.Wrapper>
            </St.Tabs.Container>
        </>
    );
}

const TAB_LIST = [
    {
        name: '불러오기',
        value: 'LOAD'
    },
    {
        name: '파레트 준비',
        value: 'PALLETS'
    },
    {
        name: '파레트 확정',
        value: 'CONFIRM'
    },
    {
        name: '제품리스트',
        value: 'ITEMS'
    },
]